<template>
  <div class="v-law-exam">
    <div class="layout-main-content">
      <div class="wrapper">
        <div class="right">
          <div class="layout-list-container">
            <div class="layout-list-header">
              <div class="exam-header">
                <span class="header-count">共 {{ total }} 份法治体检</span>
                <i-button type="primary"  class="important" @click="invokeExam">
                  <i class="one one-add" />
                  发起体检</i-button>
              </div>
            </div>
            <Spin size="large" fix v-if="loading"></Spin>
            <div
              class="layout-list-wrapper"
            >
              <div class="warpper">
                <ul
                  ref="scrollView"
                  class="exam-ul"
                >
                  <li
                    v-for="t in exams"
                    :key="t.id"
                  >
                    <div
                      class="common-box"
                      @click="checkReport(t)"
                    >
                      <div class="exam-img">
                        <img src="/img/review_icon.png">
                      </div>
                      <div class="common-box-right">
                        <div class="common-box-right-name text-overflow">{{ t.companyName }}</div>
                        <div class="common-box-right-bottom">
                          <span @click.stop="()=>{}">联系方式：{{ t.telephone || '-' }}</span>
                          <span
                            class="date is-admin-date"
                          >
                            上传于 {{ t.gmtCreate | date }}
                          </span>
                          <i
                            class="one one-delete is-admin-delete"
                            @click.stop="deleteReport(t)"
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <Page :total="total"
                    v-if="exams.length > 0 && !loading && total > pageSize"
                    :current="pageIndex"
                    :page-size="pageSize"
                    @on-change="currentPageChanged"/>


              <empty-data
                v-if="exams.length === 0 && !loading"
                :info="emptyData.info"
                :icon="emptyData.icon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <LawExamInvoke
      v-if="invokeUrl"
      :url="invokeUrl"
      @close="invokeUrl=''"
    />
  </div>
</template>

<script>
import lawExamApi from '@/api/lawExam'
import LawExamInvoke from './LawExamInvoke'
import EmptyData from '@/components/empty-data'
import {mapState } from 'vuex'

export default {
  name: 'LawExam',
  components: {EmptyData, LawExamInvoke },
  data () {
    return {
      invokeShow: false,
      show: false,
      searchKey: '',
      invokeUrl: '',
      loading: true,
      total: 0,
      pageSize: 20,
      pageIndex: 1,
      exams: []
    }
  },
  computed: {
    ...mapState('app', {
      userInfo: state => state.userinfo,
    }),
    emptyData () {
      let info = this.searchKey ? `未找到关于 “${this.searchKey}” 的相关内容` : '没有法治体检'
      let icon = this.searchKey ? 'search' : 'document'
      return { info, icon }
    },
    queryParams () {
      return {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        companyName: this.search,
        state: 0
      }
    }
  },
  watch: {
    queryParams () {
      this.fetchExams()
    },
    search () {
      this.pageIndex = 1
    }
  },
  mounted () {
    this.fetchExams()
  },
  methods: {
    currentPageChanged (page) {
      this.pageIndex = page
    },
    fetchExams () {
      this.loading = true
      let params = { ...this.queryParams }
      lawExamApi.getLawExams(params).then(res => {
        this.total = res.total || 0
        this.exams = res.list || []
        this.loading = false
      }).catch(_ => {
        this.loading = false
      })
    },
    // 发起体检
    invokeExam () {
      lawExamApi.getExamURL().then(res => {
        this.invokeUrl = res
      })
    },
    checkReport (t) {
     window.open(`#/law-exam-report?id=${t.companyId}&name=${t.companyName}`)
    },
    deleteReport (t) {
      this.$Modal.confirm({
        type: 'warning',
        title: '确认删除!',
        content: '<p>删除后无法恢复，确认删除!</p>',
        onOk: () => {
          lawExamApi.deleteLawExam({}, {paths: {companyId: t.companyId}}).then(res => {
            this.$Message.success('删除成功')
            this.pageIndex = 1
            this.fetchExams()
          })
        }
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-law-exam
  height 100%
  display flex
  flex-direction column
  .layout-list-header
    padding-bottom 20px
    .exam-header
      display flex
      justify-content space-between
      align-items center
      font-size 14px
      .important
        font-size: 14px;
        font-weight: 600;
        color: #ed6c00 !important;
        background: #f8f8f8!important;
        -webkit-box-shadow: 0 2px 4px 0 rgba(0,0,0,0.09);
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.09);
        border none
        padding: 9px 20px 9px 15px;
  .layout-list-wrapper
    .exam-ul
      width 100%
      .common-box
        height 70px
        margin-bottom 10px
        padding 0 15px 0 6px
        display flex
        align-items center
        cursor pointer
        background white
        &:hover
          .is-admin-delete
            display flex
          .is-admin-date
            display none
        .exam-img
          width 60px
          height 60px
          margin-right 6px
          img
            height 100%
            width 100%
        &-right
          flex 1
          min-width 0
          &-name
            width 100%
            font-size 17px
            font-weight 600
            color #4a4a4a
          &-bottom
            margin-top 2px
            display flex
            justify-content space-between
            align-items center
            font-size 13px
            color  #a7a7a7
            .one-delete
              display none
</style>
